import { createAction } from '@reduxjs/toolkit';
import omit from 'lodash/omit';
import lodashGet from 'lodash/get';

export const get = (action, url, params = {}, configs = {}) => {
  const client = lodashGet(configs, 'client', 'default');

  return createAction(action, () => ({
    payload: {
      client,
      request: {
        method: 'get',
        url,
        params,
        ...omit(configs, ['client']),
      },
    },
  }))();
};

export const post = (action, url, data = {}, configs = {}) => {
  const client = lodashGet(configs, 'client', 'default');

  return createAction(action, () => ({
    payload: {
      client,
      request: {
        method: 'post',
        url,
        data,
        ...omit(configs, ['client']),
      },
    },
  }))();
};

export const put = (action, url, data = {}, configs = {}) => {
  const client = lodashGet(configs, 'client', 'default');

  return createAction(action, () => ({
    payload: {
      client,
      request: {
        method: 'put',
        url,
        data,
        ...omit(configs, ['client']),
      },
    },
  }))();
};

export const deleteReq = (action, url, params = {}, configs = {}) => {
  const client = lodashGet(configs, 'client', 'default');

  return createAction(action, () => ({
    payload: {
      client,
      request: {
        method: 'delete',
        url,
        params,
        ...omit(configs, ['client']),
      },
    },
  }))();
};

export const patch = (action, url, data = {}, configs = {}) => {
  const client = lodashGet(configs, 'client', 'default');

  return createAction(action, () => ({
    payload: {
      client,
      request: {
        method: 'patch',
        url,
        data,
        ...omit(configs, ['client']),
      },
    },
  }))();
};
